module.exports = __webpack_public_path__ + "static/MP_icon-3e1a9bb1e45a8ef40007425f468ad0e0.svg";